// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/jumbotron.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/20.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    box-sizing: border-box;
}

.jumbotron {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    border-radius: 12px;
    position: relative;
    top: -100px;
    z-index: -1;
    font-family: 'Open Sans', sans-serif;
}

.jumboText {
    height: 53%;
    width: 40%;
    display: inline-block;
    position: absolute;
    top: 26%;
    left: 5%;
    color: #174f5d;
}

.jumboMainText {
    font-weight: 500;
}

.jumboImgDiv {
    height: 79%;
    width: 50%;
    display: inline-block;
    position: absolute;
    top: 25%;
    right: 2%;
    padding-left: 5%;
}

.smallScreenDiv {
    width: 75%;
    display: inline-block;
    position: relative;
    left: 14%;
    margin-bottom: 4%;
    margin-top: -150%;
    display: none;
}

.jumboImg {
    height: 100%;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

/* .ctaBtn {
    width: 15%;
    left: 3%;
    margin-top: 5%;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
} */
.ctaBtn {
    width: 180px;
    left: 5%;
    border-radius: 26px;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    border: none;
    color: white;
    height: 37px;
    position: absolute;
    bottom: 39%;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}

.introText {
    text-align: center;
    width: 80%;
    margin: auto;
    padding-bottom: 5%;
}

.section1 {
    width: 100%;
}

.section1Heading {
    font-family: 'Open Sans', sans-serif;
    color: #17213A;
    text-align: center;
    margin-bottom: 2%;
    margin-top: 2%;
}

.sec1Left {
    display: inline-block;
    width: 45%;
    height: 550px;
    position: relative;
    padding: 3%;
}

.sec1Right {
    display: inline-block;
    width: 50%;
    padding: 3%;
    padding-left: 8%;
}

.sec1Text h5 {
    margin-bottom: 0;
}

.sec1PText {
    padding-left: 11.5%;
    padding-bottom: 3%;
    padding-bottom: 4%;
}

.sec1Img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 5%;
}

.section2 {
    width: 99%;
}

.section4 {
    overflow: hidden;
}

.sec2Col {
    height: 80vh;
    margin-top: 2%;
}

.sec2Col1 {
    background-color: #f7fdf3;
    padding: 3%;
    padding-top: 5%;
    align-items: center;
    text-align: center;
}

.sec2Col2 {
    background-color: #ecf8e5;
    padding: 3%;
    align-items: center;
    text-align: center;
    padding-top: 5%;
}

.sec2Col3 {
    background-color: #dcf4ce;
    padding: 3%;
    padding-top: 5%;
    align-items: center;
    text-align: center;
}

.sec2Img {
    width: 40%;
}

.sec2Col h5 {
    margin-top: 18%;
}

.sec2Col h4 {
    margin-top: 18%;
}

.section3 {
    padding-top: 5%;
}

.myCard {
    width: 100%;
    display: inline-block;
    padding-left: 5%;
    padding-right: 5%;
    margin: 3%;
    position: relative;
    height: 300px !important;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    border: none;


}

.testimonialSlider {
    /* background-color: yellow; */
    height: 100%;
    width: 70%;
    margin: auto;
    align-items: center;
}

.testimonialImg {
    position: absolute;
    width: 120px;
    height: 120px;
    border-radius: 100%;
    top: -20%;
    right: 33%;
    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
}

.card-title {
    margin-top: 16%;
    margin-bottom: 8%;
    text-align: center;
}

.carousel-item {
    height: 500px;
    background-color: #f6f6f6;
}

.star {
    position: absolute;
    position: absolute;
    top: -3px;
    right: 10px;
    height: 50px;
    color: rgb(23, 33, 58);
}

.section4 {
    margin: auto;
    margin-top: 4%;
    padding-top: 3%;
    padding-bottom: 3%;
    width: 99%;
}

.sec4MidDiv1 {
    align-items: center;
    text-align: center;
    padding-left: 5%;
    padding-top: 6%;
    padding-bottom: 5%;
}

.sec4MidDiv2 {
    padding-left: 4%;
}

.sec4MidDiv2 h4 {
    margin-bottom: 8%;
    text-align: center;
    margin-left: -30%;
    margin-top: 4%;
    color: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-weight: bolder;
}

.sec4MidDiv2 p {
    margin-bottom: 4%;
    text-align: left;
    color: #ffffff;
}

.section5 {
    height: 80vh;
    align-items: center;
    text-align: center;
    margin-top: 5%;
}

.section5 h1 {
    color: #347571;
    width: 66%;
    margin: auto;
    margin-top: 4%;
    font-weight: 400;
}

.sec5Img {
    width: 20%;
}

.section6 {
    height: 90vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    position: relative;
    background-position: center;
    background-size: cover;
    /* margin-top: 8%; */
}

.footerContent {
    /* background-color: antiquewhite; */
    width: 70%;
    height: 400px;
    position: absolute;
    top: 25%;
    left: 14%;
}

.footerContent h4 {
    text-align: center;
    color:#17213A;
    font-weight: 700;
}

.footerIcon {
    width: 18%;
    padding-bottom: 10px;
}

.footerText {
    font-size: 15px !important;
}

.subHeadingSec6 {
    text-align: center;
    margin-top: 3%;
    color: #17213A;
}

.footerLinks {
    margin-top: 10%;
    padding-left: 10%;
}

.footerLinks h6 {
    margin-bottom: 6%;
    color: #ffffff;
}

.footerLinks p {
    margin: 0;
    padding-top: 2%;
    font-size: 14px;

}

.section2 {
    width: 100%;
    overflow: hidden;
}

/* CSS */
.ctaBtnSec2 {
    margin-left: 42%;
    width: 300px;
    margin-top: 4%;
    /* background-color: #c2fbd7; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    border-radius: 100px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    color: rgb(255, 255, 255);
    cursor: pointer;
    display: inline-block;
    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
    padding: 7px 20px;
    text-align: center;
    text-decoration: none;
    transition: all 250ms;
    border: 0;
    font-size: 16px;
    user-select: none;
    -webkit-user-select: none;
}

/* .ctaBtnSec2:hover {
    box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px;
} */

.loginBtn {
    /* background-color: #174f5d !important; */
    /* background-image: url("../images/bg.png") !important; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: #ffffff !important;
    width: 100px;
    padding: 4px;
    font-weight: 500;
    font-size: 18px;
    position: absolute;
    top: 15px;
    right: 3%;
    border: none !important;
}

.loginBtn:hover {
    background-image: none;
    /* background-color: #35b276; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    width: 100px;
    padding: 4px;
    font-weight: 500;
    font-size: 18px;
    position: absolute;
    top: 22px;
    right: 3%;
}

.topDivLanding {
    position: relative;
}

.zoom {
    transition: transform .2s;
    /* Animation */
}

.zoom:hover {
    transform: scale(1.1);
    /* color: #ffffff; */
    /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.continueToDahboardBtn {
    /* background-color: #174f5d !important; */
    /* background-image: url("../images/bg.png") !important; */
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: #ffffff !important;
    width: 12%;
    padding: 4px;
    font-weight: 500;
    font-size: 14px;
    position: absolute;
    top: 2.0%;
    right: 3%;
    border: none !important;
}

@media (min-width: 280px) and (max-width: 767px) {
    .continueToDahboardBtn {
        width: 80%; /* Adjust width for mobile */
        padding: 8px; /* Increase padding for better touch targets */
        font-size: 16px; /* Increase font size for readability */
        position: relative; /* Change position to relative for better layout */
        top: auto; /* Reset top positioning */
        right: auto; /* Reset right positioning */
        margin: 10px auto; /* Center the button with margin */
        display: block; /* Ensure it behaves as a block element */
    }
}

/* .continueToDahboardBtn:hover {
    background-image: none;
    background-color: #4F80FF;
    color: white;
    padding: 4px;
    font-weight: 500;
    position: absolute;
    top: 2.5%;
    right: 3%;
} */

.landingPagebgcolor{
    /* background-color: rgb(23 33 58); */
    color: white;
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
}


.landingCaraousel {
    height: 627px !important;
}

.landing-carousel-control-next {
    margin-top: 22% !important;
}

.landing-carousel-control-prev {
    margin-top: 22% !important;
}

.tokensBtn {
    background-color: transparent;
    border: none;
    position: absolute;
    right: 12%;
    top: 3.5%;
    z-index: 45;
    font-size: 16px;
}

@media only screen and (min-width: 1024px) and (max-width: 1187px) {
    .jumboImgDiv {
        height: 68%;
        width: 53%;
        display: inline-block;
        position: absolute;
        top: 25%;
        right: 2%;
        padding-left: 5%;
    }

    .ctaBtn {
        bottom: 39%;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .jumboImgDiv {
        height: 68%;
        width: 53%;
        display: inline-block;
        position: absolute;
        top: 25%;
        right: 2%;
        padding-left: 5%;
    }

    .loginBtn {
        width: 12%;
        font-size: 16px;
        right: 2%;
    }

    .sec1Left {
        display: inline-block;
        width: 90%;
        height: 230px;
        position: relative;
        padding: 3%;
        margin-left: 5%;
    }

    .sec1Img {
        width: 40%;
        height: 100%;
        position: absolute;
        top: 5%;
        left: 30%;
    }

    .sec1Right {
        display: inline-block;
        width: 95%;
        padding: 3%;
        padding-left: 8%;
    }

    .ctaBtn {
        bottom: 40%;
    }

    .sec2Col {
        height: 53vh;

    }

    .tokensBtn {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 12%;
        top: 3.5%;
        z-index: 45;
        font-size: 16px;
    }
}

@media only screen and (min-width: 480px) and (max-width: 768px) {
    .jumboImgDiv {
        display: none;
    }

    .smallScreenDiv {
        width: 75%;
        display: inline-block;
        position: relative;
        left: 14%;
        margin-bottom: 4%;
        margin-top: -150%;
    }

    .jumboText {
        height: 53%;
        width: 90%;
        display: inline-block;
        position: absolute;
        top: 22%;
        left: 5%;
        color: #174f5d;
    }

    .sec1Left {
        display: inline-block;
        width: 90%;
        height: 180px;
        position: relative;
        padding: 3%;
        margin-left: 5%;
        margin-bottom: 4%;
    }

    .sec1Img {
        width: 40%;
        height: 100%;
        position: absolute;
        top: 5%;
        left: 30%;
    }

    .sec1Right {
        display: inline-block;
        width: 95%;
        padding: 3%;
        padding-left: 8%;
    }

    .ctaBtn {
        bottom: 50%;
    }

    .sec2Img {
        width: 22%;
    }

    .sec2Col h5 {
        margin-top: 8%;
    }

    .sec2Col {
        height: 67vh;

    }

    .sec4MidDiv2 {
        width: 90%;
        align-items: center;
        padding-left: 6%;
        text-align: center !important;
        display: block;
        margin: auto;
    }

    .sec4MidDiv2 h4 {
        margin-left: 0%;
        margin-top: 15%;
    }

    .reviewHeading {
        margin-top: 7%;
        margin-bottom: 10%;
    }

    .testimonialImg {
        display: none;
    }

    .landing-carousel-control-next {
        margin-top: 56% !important;
    }

    .landing-carousel-control-prev {
        margin-top: 56% !important;
    }

    .tokensBtn {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 12%;
        top: 3.5%;
        z-index: 45;
        font-size: 16px;
    }
}

@media only screen and (min-width: 767px) and (max-width: 100%) {
    .custom-btnlanding {
        right:20% !important;
    }
}



@media only screen and (max-width: 480px) {
    .loginBtn {
        width: 20%;
        font-size: 14px;
        right: 1%;
        background-color: #174f5d;
    }

    .jumboImgDiv {
        display: none;
    }

    .jumboText {
        height: 53%;
        width: 90%;
        display: inline-block;
        position: absolute;
        top: 25%;
        left: 8%;
        color: #174f5d;
    }

    .sec1Left {
        display: inline-block;
        width: 90%;
        height: 170px;
        position: relative;
        padding: 3%;
        margin-left: 7%;
        margin-bottom: 4%;
    }

    .sec1Img {
        width: 40%;
        height: 100%;
        position: absolute;
        top: 5%;
        left: 30%;
    }

    .sec1Right {
        display: inline-block;
        width: 95%;
        padding: 3%;
        padding-left: 8%;
    }

    .ctaBtn {
        bottom: 37%;
        left: 6%;
    }

    .smallScreenDiv {
        width: 75%;
        display: inline-block;
        position: relative;
        left: 14%;
        margin-bottom: 8%;
        margin-top: -150%;
    }

    .jumbotron {
        height: 78vh;
    }

    .sec1RightText {
        font-size: 16px;
    }

    .sec2Img {
        width: 30%;
    }

    .sec2Col {
        height: 50vh;

    }

    .ctaBtnSec2 {
        font-size: 14px;
        width: 270px;
        display: block;
        margin: auto;
        margin-top: 12%;
    }

    .sec4MidDiv2 {
        width: 90%;
        align-items: center;
        padding-left: 6%;
        text-align: center !important;
        display: block;
        margin: auto;
    }

    .sec4MidDiv2 h4 {
        margin-left: 0%;
        margin-top: 15%;
    }

    .reviewHeading {
        margin-top: 7%;
        margin-bottom: 10%;
    }

    .testimonialImg {
        display: none;
    }

    .landing-carousel-control-next {
        margin-top: 56% !important;
    }

    .landing-carousel-control-prev {
        margin-top: 56% !important;
    }

    .tokensBtn {
        background-color: transparent;
        border: none;
        position: absolute;
        right: 12%;
        top: 3.5%;
        z-index: 45;
        font-size: 16px;
    }

    .custom-btnlanding{
        right: 1% !important;
        top: 8% !important;
    }

    .footerIcon {
        width: 50% !important;
    }
    
    .footerText {
        font-size: 15px !important;
    }
    
}


.custom-btnlanding {
    width: 180px;
    height: 40px;
    color: #fff;
    border-radius: 20px;
    padding: 10px 10px;
    font-family: 'Lato', sans-serif;
    font-weight: 500;
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    position: absolute;
    display: inline-block;
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .25),
        5px 5px 7px 0px rgba(0, 0, 0, .05),
        4px 4px 2px 0px rgba(0, 0, 0, .05);
    outline: none;
}

.custom-btnlanding-hover:hover {
    transform: translateY(-2px);
    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .25),
        8px 8px 10px 0px rgba(0, 0, 0, .1),
        6px 6px 4px 0px rgba(0, 0, 0, .1);
    opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/styleSheet/Landing.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yDAAgD;IAChD,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4EAA4E;AAChF;;AAEA;;;;;;GAMG;AACH;IACI,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,4EAA4E;AAChF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,wBAAwB;IACxB,yDAAyC;IACzC,8IAA8I;IAC9I,YAAY;;;AAGhB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,2TAA2T;AAC/T;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,yDAAyC;IACzC,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,+BAA+B;IAC/B,kEAAkE;IAClE,oBAAoB;IACpB,4EAA4E;IAC5E,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,8EAA8E;IAC9E,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;GAEG;;AAEH;IACI,0CAA0C;IAC1C,0DAA0D;IAC1D,kEAAkE;IAClE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,kEAAkE;IAClE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qFAAqF;AACzF;;AAEA;IACI,0CAA0C;IAC1C,0DAA0D;IAC1D,kEAAkE;IAClE,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI;QACI,UAAU,EAAE,4BAA4B;QACxC,YAAY,EAAE,8CAA8C;QAC5D,eAAe,EAAE,uCAAuC;QACxD,kBAAkB,EAAE,kDAAkD;QACtE,SAAS,EAAE,0BAA0B;QACrC,WAAW,EAAE,4BAA4B;QACzC,iBAAiB,EAAE,kCAAkC;QACrD,cAAc,EAAE,yCAAyC;IAC7D;AACJ;;AAEA;;;;;;;;;GASG;;AAEH;IACI,qCAAqC;IACrC,YAAY;IACZ,kEAAkE;AACtE;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,OAAO;QACP,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,6BAA6B;QAC7B,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,SAAS;QACT,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,OAAO;QACP,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;QAC7B,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;;;AAIA;IACI;QACI,UAAU;QACV,eAAe;QACf,SAAS;QACT,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,QAAQ;QACR,QAAQ;QACR,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,OAAO;QACP,SAAS;IACb;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,qBAAqB;QACrB,kBAAkB;QAClB,SAAS;QACT,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;;IAEhB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,cAAc;QACd,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,gBAAgB;QAChB,6BAA6B;QAC7B,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;QAC7B,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;IAC9B;;AAEJ;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB;;0CAEsC;IACtC,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B;;yCAEqC;IACrC,YAAY;AAChB","sourcesContent":["body {\n    box-sizing: border-box;\n}\n\n.jumbotron {\n    background-image: url(\"../images/jumbotron.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 100vh;\n    border-radius: 12px;\n    position: relative;\n    top: -100px;\n    z-index: -1;\n    font-family: 'Open Sans', sans-serif;\n}\n\n.jumboText {\n    height: 53%;\n    width: 40%;\n    display: inline-block;\n    position: absolute;\n    top: 26%;\n    left: 5%;\n    color: #174f5d;\n}\n\n.jumboMainText {\n    font-weight: 500;\n}\n\n.jumboImgDiv {\n    height: 79%;\n    width: 50%;\n    display: inline-block;\n    position: absolute;\n    top: 25%;\n    right: 2%;\n    padding-left: 5%;\n}\n\n.smallScreenDiv {\n    width: 75%;\n    display: inline-block;\n    position: relative;\n    left: 14%;\n    margin-bottom: 4%;\n    margin-top: -150%;\n    display: none;\n}\n\n.jumboImg {\n    height: 100%;\n    width: 100%;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n/* .ctaBtn {\n    width: 15%;\n    left: 3%;\n    margin-top: 5%;\n    border-radius: 15px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n} */\n.ctaBtn {\n    width: 180px;\n    left: 5%;\n    border-radius: 26px;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    border: none;\n    color: white;\n    height: 37px;\n    position: absolute;\n    bottom: 39%;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n}\n\n.introText {\n    text-align: center;\n    width: 80%;\n    margin: auto;\n    padding-bottom: 5%;\n}\n\n.section1 {\n    width: 100%;\n}\n\n.section1Heading {\n    font-family: 'Open Sans', sans-serif;\n    color: #17213A;\n    text-align: center;\n    margin-bottom: 2%;\n    margin-top: 2%;\n}\n\n.sec1Left {\n    display: inline-block;\n    width: 45%;\n    height: 550px;\n    position: relative;\n    padding: 3%;\n}\n\n.sec1Right {\n    display: inline-block;\n    width: 50%;\n    padding: 3%;\n    padding-left: 8%;\n}\n\n.sec1Text h5 {\n    margin-bottom: 0;\n}\n\n.sec1PText {\n    padding-left: 11.5%;\n    padding-bottom: 3%;\n    padding-bottom: 4%;\n}\n\n.sec1Img {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 5%;\n}\n\n.section2 {\n    width: 99%;\n}\n\n.section4 {\n    overflow: hidden;\n}\n\n.sec2Col {\n    height: 80vh;\n    margin-top: 2%;\n}\n\n.sec2Col1 {\n    background-color: #f7fdf3;\n    padding: 3%;\n    padding-top: 5%;\n    align-items: center;\n    text-align: center;\n}\n\n.sec2Col2 {\n    background-color: #ecf8e5;\n    padding: 3%;\n    align-items: center;\n    text-align: center;\n    padding-top: 5%;\n}\n\n.sec2Col3 {\n    background-color: #dcf4ce;\n    padding: 3%;\n    padding-top: 5%;\n    align-items: center;\n    text-align: center;\n}\n\n.sec2Img {\n    width: 40%;\n}\n\n.sec2Col h5 {\n    margin-top: 18%;\n}\n\n.sec2Col h4 {\n    margin-top: 18%;\n}\n\n.section3 {\n    padding-top: 5%;\n}\n\n.myCard {\n    width: 100%;\n    display: inline-block;\n    padding-left: 5%;\n    padding-right: 5%;\n    margin: 3%;\n    position: relative;\n    height: 300px !important;\n    background-image: url(\"../images/bg.png\");\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n    border: none;\n\n\n}\n\n.testimonialSlider {\n    /* background-color: yellow; */\n    height: 100%;\n    width: 70%;\n    margin: auto;\n    align-items: center;\n}\n\n.testimonialImg {\n    position: absolute;\n    width: 120px;\n    height: 120px;\n    border-radius: 100%;\n    top: -20%;\n    right: 33%;\n    box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset, rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n.card-title {\n    margin-top: 16%;\n    margin-bottom: 8%;\n    text-align: center;\n}\n\n.carousel-item {\n    height: 500px;\n    background-color: #f6f6f6;\n}\n\n.star {\n    position: absolute;\n    position: absolute;\n    top: -3px;\n    right: 10px;\n    height: 50px;\n    color: rgb(23, 33, 58);\n}\n\n.section4 {\n    margin: auto;\n    margin-top: 4%;\n    padding-top: 3%;\n    padding-bottom: 3%;\n    width: 99%;\n}\n\n.sec4MidDiv1 {\n    align-items: center;\n    text-align: center;\n    padding-left: 5%;\n    padding-top: 6%;\n    padding-bottom: 5%;\n}\n\n.sec4MidDiv2 {\n    padding-left: 4%;\n}\n\n.sec4MidDiv2 h4 {\n    margin-bottom: 8%;\n    text-align: center;\n    margin-left: -30%;\n    margin-top: 4%;\n    color: #ffffff;\n    font-family: 'Open Sans', sans-serif;\n    font-weight: bolder;\n}\n\n.sec4MidDiv2 p {\n    margin-bottom: 4%;\n    text-align: left;\n    color: #ffffff;\n}\n\n.section5 {\n    height: 80vh;\n    align-items: center;\n    text-align: center;\n    margin-top: 5%;\n}\n\n.section5 h1 {\n    color: #347571;\n    width: 66%;\n    margin: auto;\n    margin-top: 4%;\n    font-weight: 400;\n}\n\n.sec5Img {\n    width: 20%;\n}\n\n.section6 {\n    height: 90vh;\n    background-image: url(\"../images/20.png\");\n    position: relative;\n    background-position: center;\n    background-size: cover;\n    /* margin-top: 8%; */\n}\n\n.footerContent {\n    /* background-color: antiquewhite; */\n    width: 70%;\n    height: 400px;\n    position: absolute;\n    top: 25%;\n    left: 14%;\n}\n\n.footerContent h4 {\n    text-align: center;\n    color:#17213A;\n    font-weight: 700;\n}\n\n.footerIcon {\n    width: 18%;\n    padding-bottom: 10px;\n}\n\n.footerText {\n    font-size: 15px !important;\n}\n\n.subHeadingSec6 {\n    text-align: center;\n    margin-top: 3%;\n    color: #17213A;\n}\n\n.footerLinks {\n    margin-top: 10%;\n    padding-left: 10%;\n}\n\n.footerLinks h6 {\n    margin-bottom: 6%;\n    color: #ffffff;\n}\n\n.footerLinks p {\n    margin: 0;\n    padding-top: 2%;\n    font-size: 14px;\n\n}\n\n.section2 {\n    width: 100%;\n    overflow: hidden;\n}\n\n/* CSS */\n.ctaBtnSec2 {\n    margin-left: 42%;\n    width: 300px;\n    margin-top: 4%;\n    /* background-color: #c2fbd7; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    border-radius: 100px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n    color: rgb(255, 255, 255);\n    cursor: pointer;\n    display: inline-block;\n    font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;\n    padding: 7px 20px;\n    text-align: center;\n    text-decoration: none;\n    transition: all 250ms;\n    border: 0;\n    font-size: 16px;\n    user-select: none;\n    -webkit-user-select: none;\n}\n\n/* .ctaBtnSec2:hover {\n    box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px;\n} */\n\n.loginBtn {\n    /* background-color: #174f5d !important; */\n    /* background-image: url(\"../images/bg.png\") !important; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: #ffffff !important;\n    width: 100px;\n    padding: 4px;\n    font-weight: 500;\n    font-size: 18px;\n    position: absolute;\n    top: 15px;\n    right: 3%;\n    border: none !important;\n}\n\n.loginBtn:hover {\n    background-image: none;\n    /* background-color: #35b276; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    width: 100px;\n    padding: 4px;\n    font-weight: 500;\n    font-size: 18px;\n    position: absolute;\n    top: 22px;\n    right: 3%;\n}\n\n.topDivLanding {\n    position: relative;\n}\n\n.zoom {\n    transition: transform .2s;\n    /* Animation */\n}\n\n.zoom:hover {\n    transform: scale(1.1);\n    /* color: #ffffff; */\n    /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.continueToDahboardBtn {\n    /* background-color: #174f5d !important; */\n    /* background-image: url(\"../images/bg.png\") !important; */\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: #ffffff !important;\n    width: 12%;\n    padding: 4px;\n    font-weight: 500;\n    font-size: 14px;\n    position: absolute;\n    top: 2.0%;\n    right: 3%;\n    border: none !important;\n}\n\n@media (min-width: 280px) and (max-width: 767px) {\n    .continueToDahboardBtn {\n        width: 80%; /* Adjust width for mobile */\n        padding: 8px; /* Increase padding for better touch targets */\n        font-size: 16px; /* Increase font size for readability */\n        position: relative; /* Change position to relative for better layout */\n        top: auto; /* Reset top positioning */\n        right: auto; /* Reset right positioning */\n        margin: 10px auto; /* Center the button with margin */\n        display: block; /* Ensure it behaves as a block element */\n    }\n}\n\n/* .continueToDahboardBtn:hover {\n    background-image: none;\n    background-color: #4F80FF;\n    color: white;\n    padding: 4px;\n    font-weight: 500;\n    position: absolute;\n    top: 2.5%;\n    right: 3%;\n} */\n\n.landingPagebgcolor{\n    /* background-color: rgb(23 33 58); */\n    color: white;\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n}\n\n\n.landingCaraousel {\n    height: 627px !important;\n}\n\n.landing-carousel-control-next {\n    margin-top: 22% !important;\n}\n\n.landing-carousel-control-prev {\n    margin-top: 22% !important;\n}\n\n.tokensBtn {\n    background-color: transparent;\n    border: none;\n    position: absolute;\n    right: 12%;\n    top: 3.5%;\n    z-index: 45;\n    font-size: 16px;\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1187px) {\n    .jumboImgDiv {\n        height: 68%;\n        width: 53%;\n        display: inline-block;\n        position: absolute;\n        top: 25%;\n        right: 2%;\n        padding-left: 5%;\n    }\n\n    .ctaBtn {\n        bottom: 39%;\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .jumboImgDiv {\n        height: 68%;\n        width: 53%;\n        display: inline-block;\n        position: absolute;\n        top: 25%;\n        right: 2%;\n        padding-left: 5%;\n    }\n\n    .loginBtn {\n        width: 12%;\n        font-size: 16px;\n        right: 2%;\n    }\n\n    .sec1Left {\n        display: inline-block;\n        width: 90%;\n        height: 230px;\n        position: relative;\n        padding: 3%;\n        margin-left: 5%;\n    }\n\n    .sec1Img {\n        width: 40%;\n        height: 100%;\n        position: absolute;\n        top: 5%;\n        left: 30%;\n    }\n\n    .sec1Right {\n        display: inline-block;\n        width: 95%;\n        padding: 3%;\n        padding-left: 8%;\n    }\n\n    .ctaBtn {\n        bottom: 40%;\n    }\n\n    .sec2Col {\n        height: 53vh;\n\n    }\n\n    .tokensBtn {\n        background-color: transparent;\n        border: none;\n        position: absolute;\n        right: 12%;\n        top: 3.5%;\n        z-index: 45;\n        font-size: 16px;\n    }\n}\n\n@media only screen and (min-width: 480px) and (max-width: 768px) {\n    .jumboImgDiv {\n        display: none;\n    }\n\n    .smallScreenDiv {\n        width: 75%;\n        display: inline-block;\n        position: relative;\n        left: 14%;\n        margin-bottom: 4%;\n        margin-top: -150%;\n    }\n\n    .jumboText {\n        height: 53%;\n        width: 90%;\n        display: inline-block;\n        position: absolute;\n        top: 22%;\n        left: 5%;\n        color: #174f5d;\n    }\n\n    .sec1Left {\n        display: inline-block;\n        width: 90%;\n        height: 180px;\n        position: relative;\n        padding: 3%;\n        margin-left: 5%;\n        margin-bottom: 4%;\n    }\n\n    .sec1Img {\n        width: 40%;\n        height: 100%;\n        position: absolute;\n        top: 5%;\n        left: 30%;\n    }\n\n    .sec1Right {\n        display: inline-block;\n        width: 95%;\n        padding: 3%;\n        padding-left: 8%;\n    }\n\n    .ctaBtn {\n        bottom: 50%;\n    }\n\n    .sec2Img {\n        width: 22%;\n    }\n\n    .sec2Col h5 {\n        margin-top: 8%;\n    }\n\n    .sec2Col {\n        height: 67vh;\n\n    }\n\n    .sec4MidDiv2 {\n        width: 90%;\n        align-items: center;\n        padding-left: 6%;\n        text-align: center !important;\n        display: block;\n        margin: auto;\n    }\n\n    .sec4MidDiv2 h4 {\n        margin-left: 0%;\n        margin-top: 15%;\n    }\n\n    .reviewHeading {\n        margin-top: 7%;\n        margin-bottom: 10%;\n    }\n\n    .testimonialImg {\n        display: none;\n    }\n\n    .landing-carousel-control-next {\n        margin-top: 56% !important;\n    }\n\n    .landing-carousel-control-prev {\n        margin-top: 56% !important;\n    }\n\n    .tokensBtn {\n        background-color: transparent;\n        border: none;\n        position: absolute;\n        right: 12%;\n        top: 3.5%;\n        z-index: 45;\n        font-size: 16px;\n    }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 100%) {\n    .custom-btnlanding {\n        right:20% !important;\n    }\n}\n\n\n\n@media only screen and (max-width: 480px) {\n    .loginBtn {\n        width: 20%;\n        font-size: 14px;\n        right: 1%;\n        background-color: #174f5d;\n    }\n\n    .jumboImgDiv {\n        display: none;\n    }\n\n    .jumboText {\n        height: 53%;\n        width: 90%;\n        display: inline-block;\n        position: absolute;\n        top: 25%;\n        left: 8%;\n        color: #174f5d;\n    }\n\n    .sec1Left {\n        display: inline-block;\n        width: 90%;\n        height: 170px;\n        position: relative;\n        padding: 3%;\n        margin-left: 7%;\n        margin-bottom: 4%;\n    }\n\n    .sec1Img {\n        width: 40%;\n        height: 100%;\n        position: absolute;\n        top: 5%;\n        left: 30%;\n    }\n\n    .sec1Right {\n        display: inline-block;\n        width: 95%;\n        padding: 3%;\n        padding-left: 8%;\n    }\n\n    .ctaBtn {\n        bottom: 37%;\n        left: 6%;\n    }\n\n    .smallScreenDiv {\n        width: 75%;\n        display: inline-block;\n        position: relative;\n        left: 14%;\n        margin-bottom: 8%;\n        margin-top: -150%;\n    }\n\n    .jumbotron {\n        height: 78vh;\n    }\n\n    .sec1RightText {\n        font-size: 16px;\n    }\n\n    .sec2Img {\n        width: 30%;\n    }\n\n    .sec2Col {\n        height: 50vh;\n\n    }\n\n    .ctaBtnSec2 {\n        font-size: 14px;\n        width: 270px;\n        display: block;\n        margin: auto;\n        margin-top: 12%;\n    }\n\n    .sec4MidDiv2 {\n        width: 90%;\n        align-items: center;\n        padding-left: 6%;\n        text-align: center !important;\n        display: block;\n        margin: auto;\n    }\n\n    .sec4MidDiv2 h4 {\n        margin-left: 0%;\n        margin-top: 15%;\n    }\n\n    .reviewHeading {\n        margin-top: 7%;\n        margin-bottom: 10%;\n    }\n\n    .testimonialImg {\n        display: none;\n    }\n\n    .landing-carousel-control-next {\n        margin-top: 56% !important;\n    }\n\n    .landing-carousel-control-prev {\n        margin-top: 56% !important;\n    }\n\n    .tokensBtn {\n        background-color: transparent;\n        border: none;\n        position: absolute;\n        right: 12%;\n        top: 3.5%;\n        z-index: 45;\n        font-size: 16px;\n    }\n\n    .custom-btnlanding{\n        right: 1% !important;\n        top: 8% !important;\n    }\n\n    .footerIcon {\n        width: 50% !important;\n    }\n    \n    .footerText {\n        font-size: 15px !important;\n    }\n    \n}\n\n\n.custom-btnlanding {\n    width: 180px;\n    height: 40px;\n    color: #fff;\n    border-radius: 20px;\n    padding: 10px 10px;\n    font-family: 'Lato', sans-serif;\n    font-weight: 500;\n    background: transparent;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: absolute;\n    display: inline-block;\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .25),\n        5px 5px 7px 0px rgba(0, 0, 0, .05),\n        4px 4px 2px 0px rgba(0, 0, 0, .05);\n    outline: none;\n}\n\n.custom-btnlanding-hover:hover {\n    transform: translateY(-2px);\n    box-shadow: inset 2px 2px 2px 0px rgba(255, 255, 255, .25),\n        8px 8px 10px 0px rgba(0, 0, 0, .1),\n        6px 6px 4px 0px rgba(0, 0, 0, .1);\n    opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
